export enum DirectDebitTypeEnum {
    RECURRENT = "Recurrent",
    ONCE_OFF = "Once Off"
}